<template>
  <div>
    <div>
      <top-header @getUserName="getUserName"></top-header>
    </div>
    <div class="content">
      <div class="info" v-if="$route.query.type === '10'">
        <h1 id="title">{{ obj.title }}</h1>
        <div id="source">发布时间：{{ obj.publishTime }}</div>
      </div>
      <div v-html="obj.divInfo" class="info"></div>
      <div class="laiyuan" @click="source">
        来源网址:{{ obj.infoUrl || obj.sourceFrom }}
      </div>
      <div class="foot">
        <p>{{ obj.source }}</p>
        <p>{{ obj.publishTime }}</p>
      </div>

      <div class="pdf-container" id="testx" v-if="pdfUrl.length > 0">
        <iframe :src="pdfUrl" style="width: 968px; height: 863px"></iframe>
      </div>

      <div class="back" @click="backToLastPage">返回</div>

      <div class="section_9 flex-col" @click="Collection">
        <div class="block_6 flex-col" v-show="isCollection == false"></div>
        <div class="block_7 flex-col" v-show="isCollection === true"></div>
      </div>
    </div>

    <div>
      <cenfooter></cenfooter>
    </div>
  </div>
</template>

<script>
// document.getElementById("wxw-img").attr("src","xxxx.jpg");
import topHeader from "../components/home/headears.vue";
import cenfooter from "../components/home/footers.vue";
import {
  getArticleByIdList,
  getCollectionExist,
  collectionAdd,
  collectionDelete,
  getSysFileInfoPreview,
  getMedicalFrontiersDetail,
  getRotationDetail,
} from "@/api/api";

export default {
  components: {
    topHeader,
    cenfooter,
  },
  data() {
    return {
      obj: {},
      isCollection: null,
      addCollectionObj: {
        contentId: "",
        typeName: "",
        userId: "",
        userName: "",
      },
      pdfUrl: "",
    };
  },
  created() {
    this.init();
    if (parseInt(sessionStorage.getItem("isLogin")) === 1) {
      this.getCollectionExist();
    }
    setTimeout(() => {
      var a = document.querySelectorAll("img");
      for (var i = 0; i < a.length; i++) {
        if (a[i].dataset.src) {
          a[i].src = a[i].dataset.src;
        }
      }
    }, 500);
  },
  methods: {
    async init() {
      let res = {};
      if (this.$route.query.type === "10") {
        res = await getMedicalFrontiersDetail({
          id: this.$route.query.id,
        });
        this.obj = res.data.data;
        if (this.obj.filedId) {
          this.getpdf(this.obj.filedId);
        }
        window.document.title = "医学科教信息平台-" + res.data.data.title;
        this.obj.divInfo = res.data.data.content;
      } else {
        if (this.$route.query.type === "1") {
          res = await getRotationDetail({
            id: this.$route.query.id,
          });
        } else {
          res = await getArticleByIdList({
            id: this.$route.query.id,
            type: this.$route.query.type
          });
        }
        this.obj = res.data;
        if (this.$route.query.type === "1") {
          this.obj = res.data.data;
        }
        let keyWordStr = `<br><div style="text-align: center; color: #409EFF;">关键词： ${res.data.keyWord.replaceAll(
          "/",
          ", "
        )}</div>`;
        let index = this.findPosition(res.data.divInfo, "\n", 0);
        window.document.title = "医学科教信息平台-" + res.data.title;
        res.data.divInfo =
          res.data.divInfo.slice(0, index + 1) +
          keyWordStr +
          res.data.divInfo.slice(index + 1);
      }
    },
    getpdf(id) {
      getSysFileInfoPreview(id, true).then((res) => {
        if (res) {
          this.pdfUrl = window.URL.createObjectURL(res.data);
        }
      });
    },
    source() {
      var temp = this.obj.infoUrl ? this.obj.infoUrl : this.obj.sourceFrom;
      window.open(temp);
    },
    async Collection() {
      if (!this.isCollection) {
        this.addCollectionObj.contentId = this.$route.query.id;
        this.addCollectionObj.typeName = "资讯";
        await collectionAdd(this.addCollectionObj);
        this.isCollection = !this.isCollection;
        this.$message.success("收藏成功");
      } else {
        await collectionDelete(this.$route.query.id);
        this.isCollection = !this.isCollection;
        this.$message.success("取消收藏成功");
      }

      // this.getCollectionExist();
    },
    //是否收藏
    async getCollectionExist() {
      const res = await getCollectionExist(this.$route.query.id);
      this.isCollection = res.data;
    },
    getUserName(e) {
      this.addCollectionObj.userId = e.id;
      this.addCollectionObj.userName = e.name;
    },
    findPosition(str, queryStr, pon) {
      var x = str.indexOf(queryStr);
      for (let i = 0; i < pon; i++) {
        x = str.indexOf(queryStr, x + 1);
      }
      return x;
    },
    backToLastPage() {
      window.close();
      // this.$router.back(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.info ::v-deep .rich_media_content {
  visibility: visible !important;
}
.content {
  width: 90%;
  height: 100%;
  background-color: #fff;
  margin: 20px auto;
  // position: relative;
  padding: 24px 24px 225px 24px;
  #keyword {
    width: 100%;
    text-align: center;
    color: skyblue;
  }

  .back {
    width: 100%;
    cursor: pointer;
    color: #0b70c1;
    text-align: center;
  }
  .laiyuan {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0b70c1;
    line-height: 24px;
    cursor: pointer;
    margin-bottom: 44px;
  }

  .foot {
    float: right;
    // text-align: right;
    // overflow: hidden;
    width: 140px;
    height: 48px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.9);
    line-height: 24px;
  }
  .section_9 {
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 50%;
    height: 40px;
    width: 40px;
    position: fixed;
    right: 2%;
    top: 50%;
    .block_6 {
      width: 22px;
      height: 22px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngf81f7c58cafe59ef9d9b97b5b767b4874bd05714f7d71d994de4a18ecc1501a0)
        100% no-repeat;
      background-size: 100% 100%;
      background-color: rgba(255, 255, 255, 1);

      margin: 9px 0 0 9px;
    }
    .block_7 {
      width: 22px;
      height: 22px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc3e0fe841bda6bd58bfddb4721223628a91073b97d2658312cddc7f99267dec4)
        100% no-repeat;
      background-size: 100% 100%;
      margin: 9px 0 0 9px;
    }
  }

  .info {
    ::v-deep a {
      color: #0b70c1 !important;
    }
    ::v-deep h1 {
      text-align: center;
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 28px;
    }
    ::v-deep #source {
      text-align: center;
      margin-top: 24px;
      margin-bottom: 47px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4);
      line-height: 12px;
    }
    ::v-deep p {
      padding-left: 8px;
      padding-right: 8px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.9);
      line-height: 24px;
    }
  }
}
.flex-row {
  display: flex;
}
.pdf-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.block_2 {
  // box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
  // background-color: rgba(255, 255, 255, 1);
  // position: relative;
  // width: 1264px;
  height: 748px;
  // margin: 32px 0 0 88px;

  // width: 80%;
  background-color: #fff;
  // margin: 20px auto;
  margin: 0 auto;
  padding: 50px;
  .text_6 {
    color: rgba(0, 0, 0, 1);
    font-size: 22px;
    font-family: PingFangSC-Semibold;
    // text-align: right;
    white-space: nowrap;

    text-align: center;
  }
  .box_1 {
    width: 100%;
    height: 12px;
    margin-top: 24px;
    display: flex;
    justify-content: center;
    .block_3 {
      width: 12px;
      height: 12px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng766fa97a9aacfd6353aedd9fa852c34dbc4d7e294d0286d68dc8f7db0da362fa)
        100% no-repeat;
      background-size: 100% 100%;
    }
    .text_7 {
      width: 96px;
      height: 12px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      text-align: right;
      white-space: nowrap;
      line-height: 12px;
      margin-left: 8px;
    }
    .block_4 {
      background-color: rgba(0, 0, 0, 0.4);
      width: 1px;
      height: 12px;
      margin-left: 16px;
    }
    .block_5 {
      width: 12px;
      height: 12px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng1ca668361bd27a2abf9a1dbb7d6635d102f4d2ff7e750f144c99cbef4775ad41)
        100% no-repeat;
      background-size: 100% 100%;
      margin-left: 16px;
    }
    .text_8 {
      width: 130px;
      height: 12px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.4);
      font-size: 12px;
      text-align: right;
      white-space: nowrap;
      line-height: 12px;
      margin-left: 8px;
    }
  }
  .section_7 {
    width: 100%;
    height: 1px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng4f2cff8e6ed7f065a0cd6621f8973c753e11fdf07a7ea1dc761fda6407fab062)
      0px -1px no-repeat;
    background-size: 1216px 3px;
    margin: 24px 0;
  }
  .paragraph_1 {
    width: 100%;
    height: 192px;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 14px;
    // text-align: left;
    line-height: 24px;
    margin: 22px 0 0 32px;
  }
  .box_2 {
    width: 614px;
    height: 24px;
    margin: 24px 0 0 32px;
    .text_9 {
      width: 42px;
      height: 24px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.9);
      font-size: 14px;
      text-align: left;
      white-space: nowrap;
      line-height: 24px;
    }
    .group_1 {
      width: 14px;
      height: 14px;
      background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngde7744c4655fe38c040e24ea687532e10ae59dd0aadcdeca8ff5922660493f19)
        100% no-repeat;
      background-size: 100% 100%;
      margin: 5px 0 0 4px;
    }
    .text_10 {
      width: 546px;
      height: 24px;
      overflow-wrap: break-word;
      color: rgba(11, 112, 193, 1);
      font-size: 14px;
      text-align: left;
      white-space: nowrap;
      line-height: 24px;
      margin-left: 8px;
    }
  }
  .text-wrapper_2 {
    width: 140px;
    height: 48px;
    overflow-wrap: break-word;
    font-size: 0;
    text-align: center;
    line-height: 24px;
    float: right;
    .paragraph_2 {
      width: 140px;
      height: 48px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.9);
      font-size: 14px;
      text-align: left;
      line-height: 24px;
    }
    .text_11 {
      width: 140px;
      height: 48px;
      overflow-wrap: break-word;
      color: rgba(0, 0, 0, 0.9);
      font-size: 14px;
      font-family: Helvetica;
      text-align: left;
      line-height: 24px;
    }
  }
}
</style>